import { StyleObject } from 'styletron-react';

export const keyHeading: StyleObject = {
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-evenly',
	alignItems: 'center',
	height: '45%',
	flexWrap: 'wrap',
	gap: '25px'
};
export const subKeyHeading: StyleObject = {
	height: '130px',
	width: '40%',
	cursor: 'pointer',
	display: 'flex',
	justifyContent: 'space-around'
};
